import { BudgetTransfer } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const BudgetTransferPage = ({ isCopy, isEdit }: IOperationPageProps) => (
  <BudgetTransfer isCopy={isCopy} isEdit={isEdit}/>
);
